import { render } from "./BaseContextMenu.vue?vue&type=template&id=1561188e"
import script from "./BaseContextMenu.vue?vue&type=script&lang=js"
export * from "./BaseContextMenu.vue?vue&type=script&lang=js"

import "./BaseContextMenu.vue?vue&type=style&index=0&id=1561188e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__